import Decimal from 'decimal.js';
import moment from 'moment-timezone';

export const convertToNumber = (value: string | number, ignoreDecimal = false): number => {
    if (typeof value === 'string') {
        const condition = new RegExp(ignoreDecimal ? '[^0-9]' : '[^0-9.]', 'g');
        if (ignoreDecimal && value.lastIndexOf('.') > 0) {
            // If multiple decimals return NaN
            if ((value.match(/\./g) || []).length > 1) {
                return NaN;
            }
            value = value.substring(0, value.lastIndexOf('.'));
        }

        return Number(value.replace(condition, ''));
    } else if (typeof value === 'number') {
        if (ignoreDecimal) {
            return Math.floor(value);
        }

        return value;
    }

    return NaN;
};

export const convertToNumberString = (
    value: string,
    opts: { ignoreDecimal?: boolean } = { ignoreDecimal: false }
): string => {
    if (opts?.ignoreDecimal) {
        return value.replace(/[^0-9]/g, '');
    }

    return value.replace(/[^0-9.]/g, '');
};

export const formatEpochDate = (timeEpoch: moment.MomentInput, format = 'MMM DD YYYY HH:mm:ss'): string => {
    if (!timeEpoch) return '';

    const date = moment(timeEpoch, 'x');
    if (date.isValid() && timeEpoch !== '0') return date.format(format);
    else return '';
};

export const capitalizeFirstLetter = (value: string, lowercaseOther?: boolean): string => {
    if (lowercaseOther) {
        return value.charAt(0)
            .toLocaleUpperCase() +
            value.slice(1)
                .toLocaleLowerCase();
    }

    return value.charAt(0)
        .toLocaleUpperCase() + value.slice(1);
};

export const multiplySafe = (
    value1: number,
    value2: number
): number => {
    if (isNaN(value1) || isNaN(value2)) {
        return NaN;
    }

    let total = new Decimal(0.0);
    total = Decimal.mul(new Decimal(value1), new Decimal(value2));

    return total.toNumber();
};

export const addSafe = (
    value1: number,
    value2: number
): number => {
    if (isNaN(value1) || isNaN(value2)) {
        return NaN;
    }

    let total = new Decimal(0.0);
    total = Decimal.add(new Decimal(value1), new Decimal(value2));

    return total.toNumber();
};